// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_88-6";
export var headerCell = "_88-2";
export var loadingStateContent = "_88-8";
export var rowWrapper = "_88-4";
export var stickyAggregationCell = "_88-b";
export var stickyAggregationRow = "_88-7";
export var stickyColumnCell = "_88-a";
export var stickyColumnHeaderCell = "_88-9";
export var table = "_88-1";
export var virtualRowWrapper = "_88-5";
export var virtualTableBodyFiller = "_88-d";
export var virtualTableBodyFillerBottom = "_88-e";
export var virtualTableContainer = "_88-0";
export var virtualTableContainerFill = "_88-c";
export var white = "_88-3";